export default "__VITE_ASSET__CaIjcLOe__"